import React, { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setTheme } from "../../../redux/themes/themeSlice";
import styled from "@emotion/styled";
import { ifacSecurityURL } from "../../../../src/utility/apiURLS"
import { getAuthToken, getuserId } from "../../../../src/utility/tokenUtility"
import axios from "axios";
import PageLoader from "../../../components/commoncomponents/PageLoader";

function ToggleTheme() {
  const [loading, setLoading] = useState(false)
  const color = localStorage.getItem('theme')
  const dispatch = useDispatch();
  // console.log(mode, color);
  const handleToggleTheme = (color) => {
    dispatch(setTheme(color));
    localStorage.setItem('theme', color)
    updateTheme(color)
  };

  const updateTheme = async (color) => {
    const token = getAuthToken("id_token");
    const userId = getuserId("")
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const postData = {
      theme: color
    }

    const endpoint = `${ifacSecurityURL}/api/GraphUserdetails/GetUserThemeAndWidgetsList/${userId}`
    setLoading(true);
    try {
      await axios({
        method: "put",
        url: endpoint,
        headers: config.headers,
        data: postData,
      }).then((response) => {
        localStorage.setItem('widgets', response?.data?.widgets)
      });
    } catch (error) {
      console.log(error);

    } finally {
      setLoading(false);
    }
  }

  const StyledThemeIcon = styled(Typography)(({ theme, bgcolor, shadow }) => {
    // console.log(theme);
    return {
      width: 16,
      height: 16,
      backgroundColor: bgcolor,
      borderRadius: "50%",
      cursor: "pointer",
      transition: "box-shadow 0.3s",
      "&:not(.active):hover,&.active": {
        boxShadow: `0 0 0 3px ${shadow}`,
      },
    };
  });

  return (
    <>
      <PageLoader open={loading} />
      <Box px={2} py={1}>
        <Typography mb={1}>Themes</Typography>
        <Stack direction="row" spacing={1.5} useFlexGap>
          <StyledThemeIcon
            className={`${color === "default" ? "active" : null
              }`}
            bgcolor="rgba(167, 123, 202, 1)"
            shadow="rgba(167, 123, 202, 0.4)"
            onClick={() =>
              handleToggleTheme("default")
            }
          />

          <StyledThemeIcon
            className={`${color === "blue" ? "active" : null
              }`}
            bgcolor="rgba(98, 181, 221, 1)"
            shadow="rgba(98, 181, 221, 0.4)"
            onClick={() => handleToggleTheme("blue")}
          />

          <StyledThemeIcon
            className={`${color === "green" ? "active" : null
              }`}
            bgcolor="rgba(129, 196, 77, 1)"
            shadow="rgba(129, 196, 77, 0.4)"
            onClick={() => handleToggleTheme("green")}
          />

          {/* Dark Icon displayed only on Light Mode */}
          <StyledThemeIcon
            className={`${color === "dark" ? "active" : null}`}
            bgcolor="rgba(29, 30, 29, 1)"
            shadow={
              color === "dark"
                ? "rgba(255, 255, 255, 0.4)"
                : "rgba(29, 30, 29, 0.4)"
            }
            onClick={() => handleToggleTheme("dark")}
          />
        </Stack>
      </Box>
    </>
  );
}

export default ToggleTheme;
